import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import Retry from "./RetryMessage";
import { s360ConfigService } from "../../Services/S360Config";

class TextMessage extends Component {
  isLink(string) {
    if (
      (!isNullOrUndefined(string) && string?.includes("https://")) ||
      string?.includes("http://")
    ) {
      return true;
    } else {
      return false;
    }
  }
  extractLinkFunction = (message) => {
    if (message.includes("href")) {
      message.match(/\bhttps?:\/\/\S+/gi);
      if (
        message.match(/"([^"]*)"/)[0].length >= 2 &&
        message.match(/"([^"]*)"/)[0].charAt(0) == '"' &&
        message
          .match(/"([^"]*)"/)[0]
          .charAt(message.match(/"([^"]*)"/)[0].length - 1) == '"'
      ) {
        message = message
          .match(/"([^"]*)"/)[0]
          .substring(1, message.match(/"([^"]*)"/)[0].length - 1);
      }

      return message;
    } else return message;
  };

  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      case MessageType.info:
        return this.props.convoType === "TRANSFER"
          ? "s360-message-box-info-agent"
          : "s360-message-box-info";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return s360ConfigService.config.autoFullScreen
          ? "s360-message-cotainer-received-fs"
          : "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.sent:
        return {
          background: config.designDetails.recieverMessageColor,
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
          padding: config.designDetails.paddingText,
          fontWeight: config.designDetails.senderFontWeight || 500,
        };
      case MessageType.received:
        return {
          background: config.designDetails.senderMessageColor,
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageFontColor,
        };
      default:
        return {};
    }
  };
  emojiStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          background: config.designDetails.senderMessageColor,
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      case MessageType.sent:
        return {
          background: "white",
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
          padding: config.designDetails.paddingText,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.sent:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  render() {
    console.log(
      "textt msgg",
      this.props,
      typeof this?.props?.message?.showSingleTick
    );

    const { message } = this.props;
    let text = this?.props?.message?.message?.text;
    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        {this.isLink(this?.props?.message?.message?.text) ? (
          <div
            className={this.messageBoxClassName()}
            style={this.messageBoxStyle()}
          >
            <a
              target="_blank"
              rel="noreferrer"
              href={this.extractLinkFunction(
                this?.props?.message?.message?.text
              )}
            >
              {this?.props?.message?.message?.text}
            </a>
            <br />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
            }}
          >
            <div
              className={this.messageBoxClassName()}
              style={this.messageBoxStyle()}
              dangerouslySetInnerHTML={{ __html: text }}
            >
              {/* <br /> */}
            </div>
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
          {this.showMessageTime() && (
            <div
              className={this.messageTimeClassName()}
              style={this.messageTimeStyle()}
            >
              {dayjs
                .unix(
                  Math.trunc(
                    this?.props?.message?.message?.sentTimestamp / 1000
                  )
                )
                .format("DD MMM h:mm a")}
            </div>
          )}

          <Retry {...this.props} />
        </div>
      </div>
    );
  }
}

export default TextMessage;
